let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bQdtz")).then(() => parcelRequire('dtdQ0'));